import { FormLabel as ChakraFormLabel, HStack, Text } from "@chakra-ui/react"
import { InfoPopover } from "../InfoPopover/InfoPopover"
import { RequiredIndicator } from "./RequiredIndicator"

export const FormLabel = ({ children, helperText, required, ...rest }) => (
    <ChakraFormLabel fontWeight='500' whiteSpace='nowrap' {...rest}>
        <HStack spacing={0}>
            <Text>{children}{required && !rest.disabled && <RequiredIndicator/>}</Text>
            {helperText && <InfoPopover helperText={helperText} />}
        </HStack>
    </ChakraFormLabel>
)